import { Button } from "@stacklet/ui";
import { useNavigate } from "react-router";

export function NotFound() {
  const navigate = useNavigate();

  return (
    <div className="flex min-h-screen flex-col items-center justify-center">
      <div className="mb-xs text-display-large">Error 404</div>
      <div className="mb-xl text-body-large">
        The page you were looking for could not be found
      </div>
      <Button onPress={() => navigate(-1)} variant="primary">
        Go back
      </Button>
    </div>
  );
}
